import * as React from 'react';

export function SvgGoogleDrive(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.51203 18.4269L4.39404 19.9615C4.57732 20.2846 4.84078 20.5385 5.15006 20.7231L8.30011 15.2308H2C2 15.5885 2.09164 15.9462 2.27491 16.2692L3.51203 18.4269Z"
        fill="#0066DA"
      />
      <path
        d="M12 8.76923L8.84994 3.27692C8.54066 3.46154 8.2772 3.71538 8.09393 4.03846L2.27491 14.1923C2.09501 14.5084 2.00024 14.8664 2 15.2308H8.30011L12 8.76923Z"
        fill="#00AC47"
      />
      <path
        d="M18.8499 20.7231C19.1592 20.5385 19.4227 20.2846 19.606 19.9615L19.9725 19.3269L21.7251 16.2692C21.9084 15.9462 22 15.5885 22 15.2308H15.6994L17.0401 17.8846L18.8499 20.7231Z"
        fill="#EA4335"
      />
      <path
        d="M12 8.76923L15.1501 3.27692C14.8408 3.09231 14.4857 3 14.1191 3H9.88087C9.51432 3 9.15922 3.10385 8.84994 3.27692L12 8.76923Z"
        fill="#00832D"
      />
      <path
        d="M15.6994 15.2308H8.30011L5.15006 20.7231C5.45934 20.9077 5.81443 21 6.18098 21H17.819C18.1856 21 18.5407 20.8962 18.8499 20.7231L15.6994 15.2308Z"
        fill="#2684FC"
      />
      <path
        d="M18.8156 9.11538L15.9061 4.03846C15.7228 3.71538 15.4593 3.46154 15.1501 3.27692L12 8.76923L15.6994 15.2308H21.9885C21.9885 14.8731 21.8969 14.5154 21.7136 14.1923L18.8156 9.11538Z"
        fill="#FFBA00"
      />
    </svg>
  );
}
